import React, { useState } from "react";
import Dropdown from "../Dropdown/Dropdown";
import Header from "../Header/Header";
import {
  HeroContainer,
  HeroWrapper,
  HeroLeft,
  HeroRight,
  Image,
  ScrollDown,
  ScrollLink,
} from "./HeroElements";
function Hero() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <main>
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Header toggle={toggle} />
      <HeroContainer>
        <HeroWrapper>
          <HeroLeft>
            <h1>
              Mitt navn er <br /> Sander Pettersen
            </h1>
            <h5>Student</h5>
          </HeroLeft>
          <HeroRight>
            <Image
              src="https://scontent.fsvg1-1.fna.fbcdn.net/v/t1.6435-1/82219553_123467302491122_1947972435596804096_n.jpg?stp=dst-jpg_p200x200&_nc_cat=105&ccb=1-7&_nc_sid=7206a8&_nc_ohc=h2OCpcb_0HwAX_FX_FB&_nc_ht=scontent.fsvg1-1.fna&oh=00_AT8WxhSNlkdeQ5dZuWkCOC06F1tU2SxDgv0WdMgakZeswQ&oe=62BEE3B1"
              alt="Facebook profilbilde"
              className="HeroImage"
            />
          </HeroRight>
        </HeroWrapper>
        <ScrollDown to="projects">
          <ScrollLink>
            Scroll videre
            <img
              src="https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/scroll-down.svg"
              alt="scroll-down"
            />
          </ScrollLink>
        </ScrollDown>
      </HeroContainer>
    </main>
  );
}

export default Hero;
